import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";

export class DeleteEndpoint implements IDeleteEndpoint
{
    public async execute(buildingId: number, spaceCateringId: string): Promise<void>
    {
        try
        {
            await axios.delete(`${apis.allApiv2}${buildingId}/catering-menuitem/${spaceCateringId}`);
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface IDeleteEndpoint
{
    execute(buildingId: number, spaceCateringId: string): Promise<void>;
}
